<div class="footer"><div class="container"><div class="pic"> <img src="@/assets/images/footer-warn.png" alt=""></div></div></div>